import SellerCard from '@c/cards/SellerCard';
import { SellerAccolades } from '@c/seller/Accolades';
import { ProductDocument } from '@models/product';
import { PublicUserDocument } from '@models/user';
import { useAuth } from 'context/AuthContext';

const SellerInfo = ({
  product,
  seller,
}: {
  product: ProductDocument;
  seller?: PublicUserDocument | null;
}) => {
  const { userDoc } = useAuth();

  return (
    <div className="mt-[3rem]">
      {seller ? (
        <div>
          <SellerCard uid={userDoc?.uid} sellerDoc={seller} product={product} />
          <div className="flex flex-col gap-[2.4rem]">
            {(seller.badge_counts.as_described > 9 ||
              seller.badge_counts.fast_shipper > 9 ||
              seller.badge_counts.quick_replies > 9) && (
              <>
                <hr className="my-[2rem]" />

                <SellerAccolades {...seller.badge_counts} />
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="flex flex-row items-center justify-start">
          {/* skeleton */}
          <div className="flex animate-pulse flex-row items-center gap-[1.6rem]">
            <div className="h-[4.8rem] w-[4.8rem] rounded-full bg-gray-300"></div>
            <div className="flex flex-col gap-[0.8rem]">
              <div className="h-[2.4rem] w-[20rem] rounded bg-gray-300"></div>
              <div className="h-[2.4rem] w-[12rem] rounded bg-gray-300"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SellerInfo;
